import auth from './auth';
import recipients from './recipients';
import orgs from './orgs';
import users from './users';
import duplicates from './duplicates';

const mutations = {
  ...auth,
  ...recipients,
  ...orgs,
  ...users,
  ...duplicates,
};

export default mutations;

